import React from "react";
import { connect } from "react-redux";

import MainContainer from "../../components/mainContainer/index";

import inits from "../../engine/inits";

import { fetchUrl } from "../../config/utils";
import { nameClases } from "../../config/config";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrophy, faSkull, faSearch } from "@fortawesome/free-solid-svg-icons";

import style from "./style.scss";

// Medalla por podio.
const RANK_STYLE = {
    1: { className: "rankGold",   emoji: "🥇" },
    2: { className: "rankSilver", emoji: "🥈" },
    3: { className: "rankBronze", emoji: "🥉" }
};

// Cantidad de filas skeleton a mostrar mientras loading.
const SKELETON_ROW_COUNT = 8;

class RankingPage extends React.Component {
    // getInitialProps SOLO devuelve userAgent — mismo patrón que /wiki.
    // El fetch del ranking vive en componentDidMount client-side para que
    // el primer click navegue instantáneamente.
    static async getInitialProps({ req }) {
        const userAgent = req
            ? req.headers["user-agent"]
            : typeof navigator !== "undefined"
            ? navigator.userAgent
            : "";
        return { userAgent };
    }

    state = {
        rankingList: [],
        loading: true,
        error: false,
        search: "",
        // Sprites pre-computados — head/body/helmet numFiles por personaje.
        // Se computan cuando inits cargan Y rankingList ya llegó.
        sprites: {}
    };

    componentDidMount() {
        this._unmounted = false;
        this.fetchRanking();
        // Si inits ya están cargados (cache de navegación previa), tratá
        // de computar sprites en cuanto llegue rankingList.
        this.maybeComputeSprites();
    }

    componentDidUpdate(prevProps, prevState) {
        // Recompute sprites cuando cualquiera de los dos cambia: inits
        // termina de cargar, o rankingList llega del fetch.
        const initsJustLoaded =
            !prevProps.initsLoaded && this.props.initsLoaded;
        const rankingJustLoaded =
            prevState.rankingList.length === 0 &&
            this.state.rankingList.length > 0;
        if (initsJustLoaded || rankingJustLoaded) {
            this.maybeComputeSprites();
        }
    }

    componentWillUnmount() {
        this._unmounted = true;
    }

    fetchRanking = async () => {
        try {
            const r = await fetchUrl("/ranking/general");
            if (this._unmounted) return;
            this.setState({
                rankingList: Array.isArray(r) ? r : [],
                loading: false,
                error: false
            });
        } catch (e) {
            if (this._unmounted) return;
            this.setState({ rankingList: [], loading: false, error: true });
        }
    };

    handleSearch = e => {
        this.setState({ search: e.target.value });
    };

    getFilteredList = () => {
        const { rankingList, search } = this.state;
        const q = search.trim().toLowerCase();
        if (!q) return rankingList;
        return rankingList.filter(c =>
            (c.name || "").toLowerCase().includes(q)
        );
    };

    // Guard: solo computa si tenemos ambas cosas (inits + rankingList).
    maybeComputeSprites = () => {
        if (!this.props.initsLoaded) return;
        if (this.state.rankingList.length === 0) return;
        this.computeSprites();
    };

    // Para cada char en el ranking, resuelve los numFile de head/body/helmet
    // siguiendo el mismo patrón que el original (engine.heads / bodies /
    // graphics / cascos).
    computeSprites = () => {
        const { rankingList } = this.state;
        const sprites = {};

        rankingList.forEach((character, index) => {
            try {
                let idHead = character.idHead;
                if (character.navegando || character.dead) {
                    idHead = character.idLastHead;
                }
                let idBody = character.idBody;
                if (character.navegando || character.dead) {
                    idBody = character.idLastBody;
                }
                const idHelmet = character.idHelmet;

                const grhCabeza =
                    idHead && inits.heads && inits.heads[idHead]
                        ? inits.heads[idHead][2]
                        : 0;
                const graphicGrhHead =
                    grhCabeza && inits.graphics
                        ? inits.graphics[grhCabeza] || {}
                        : {};

                const grhHelmet =
                    idHelmet && inits.cascos
                        ? inits.cascos[idHelmet]
                        : null;
                const graphicGrhHelmet =
                    grhHelmet && grhHelmet[2] && inits.graphics
                        ? inits.graphics[grhHelmet[2]] || {}
                        : {};

                const grhRopa =
                    idBody && inits.bodies && inits.bodies[idBody]
                        ? inits.bodies[idBody][2]
                        : 0;
                const ropaGrh =
                    grhRopa && inits.graphics
                        ? inits.graphics[grhRopa]
                        : null;
                const currentGrhRopa =
                    ropaGrh && ropaGrh.frames ? ropaGrh.frames[1] : null;
                const graphicsGrhRopa =
                    currentGrhRopa && inits.graphics
                        ? inits.graphics[currentGrhRopa] || {}
                        : {};

                sprites[index] = {
                    headNumFile: graphicGrhHead.numFile || "",
                    helmetNumFile: graphicGrhHelmet.numFile || "",
                    helmetOffsetY: (grhHelmet && grhHelmet.offsetY) || "",
                    bodyNumFile: graphicsGrhRopa.numFile || "",
                    posY:
                        character.idRaza == 4 || character.idRaza == 5
                            ? "-9px"
                            : "0"
                };
            } catch (e) {
                sprites[index] = {};
            }
        });

        if (this._unmounted) return;
        this.setState({ sprites });
    };

    renderSkeletonRow = i => (
        <div key={`sk-${i}`} className={style.row + " " + style.skeletonRow}>
            <div className={style.colRank}>
                <span className={style.skelDot} />
            </div>
            <div className={style.colChar}>
                <div className={style.skelAvatar} />
                <span className={style.skelLine} />
            </div>
            <div className={style.colLevel}>
                <span className={style.skelPill} />
            </div>
            <div className={style.colClase}>
                <span className={style.skelLineShort} />
            </div>
            <div className={style.colKills}>
                <span className={style.skelLineShort} />
            </div>
        </div>
    );

    renderRow = (character, index) => {
        const position = index + 1;
        const podium = RANK_STYLE[position];
        const kills =
            (character.ciudadanosMatados || 0) +
            (character.criminalesMatados || 0);
        const spr = this.state.sprites[index] || {};

        return (
            <div
                key={character._id || index}
                className={`${style.row} ${
                    podium ? style[podium.className] : ""
                }`}
            >
                <div className={style.colRank}>
                    <span className={podium ? style.rankBadge : style.rankNum}>
                        {podium ? podium.emoji : position}
                    </span>
                </div>

                <div className={style.colChar}>
                    <div className={style.character}>
                        <div
                            className={style.bodyImgCharacter}
                            style={{
                                backgroundImage: spr.bodyNumFile
                                    ? `url("/static/graficos/${spr.bodyNumFile}.png")`
                                    : "none",
                                backgroundPositionY: spr.posY || 0
                            }}
                        />
                        <div
                            className={style.headImgCharacter}
                            style={{
                                backgroundImage: spr.headNumFile
                                    ? `url("/static/graficos/${spr.headNumFile}.png")`
                                    : ""
                            }}
                        />
                        <div
                            className={style.helmetImgCharacter}
                            style={{
                                backgroundImage: spr.helmetNumFile
                                    ? `url("/static/graficos/${spr.helmetNumFile}.png")`
                                    : "",
                                backgroundPositionY:
                                    spr.helmetOffsetY || 0
                            }}
                        />
                    </div>
                    <span
                        className={`${style.charName} ${
                            character.criminal
                                ? style.criminal
                                : style.ciudadano
                        }`}
                    >
                        {character.name}
                    </span>
                </div>

                <div className={style.colLevel}>
                    <span className={style.levelBadge}>
                        {character.level}
                    </span>
                </div>

                <div className={style.colClase}>
                    {nameClases[character.idClase] || "—"}
                </div>

                <div className={style.colKills}>
                    <FontAwesomeIcon
                        icon={faSkull}
                        className={style.killsIcon}
                    />
                    <span className={style.killsValue}>{kills}</span>
                </div>
            </div>
        );
    };

    render() {
        const { userAgent } = this.props;
        const { rankingList, loading, error, search } = this.state;
        const filtered = this.getFilteredList();

        const totalKillsTop = rankingList
            .slice(0, 3)
            .reduce(
                (acc, c) =>
                    acc +
                    (c.ciudadanosMatados || 0) +
                    (c.criminalesMatados || 0),
                0
            );

        return (
            <MainContainer userAgent={userAgent}>
                <div className={style.page}>
                    <div className={style.card}>
                        <div className={style.cardHeader}>
                            <FontAwesomeIcon icon={faTrophy} />
                            <h2>Ranking</h2>
                            <span className={style.subtitle}>
                                {loading
                                    ? "Cargando"
                                    : `${rankingList.length} personajes`}
                            </span>
                        </div>

                        <div className={style.searchBar}>
                            <FontAwesomeIcon
                                icon={faSearch}
                                className={style.searchIcon}
                            />
                            <input
                                type="text"
                                placeholder="Buscar por nombre..."
                                value={search}
                                onChange={this.handleSearch}
                                className={style.searchInput}
                                disabled={loading}
                            />
                        </div>

                        <div className={style.tableHeader}>
                            <div className={style.colRank}>#</div>
                            <div className={style.colChar}>Personaje</div>
                            <div className={style.colLevel}>Nivel</div>
                            <div className={style.colClase}>Clase</div>
                            <div className={style.colKills}>
                                <FontAwesomeIcon
                                    icon={faSkull}
                                    className={style.killsIcon}
                                />
                                Kills
                            </div>
                        </div>

                        <div className={style.tableBody}>
                            {loading &&
                                Array.from(
                                    { length: SKELETON_ROW_COUNT },
                                    (_, i) => this.renderSkeletonRow(i)
                                )}

                            {!loading && error && (
                                <div className={style.emptyState}>
                                    No pudimos cargar el ranking. Intentá
                                    refrescar la página.
                                </div>
                            )}

                            {!loading &&
                                !error &&
                                rankingList.length === 0 && (
                                    <div className={style.emptyState}>
                                        Aún no hay personajes en el ranking.
                                    </div>
                                )}

                            {!loading &&
                                !error &&
                                rankingList.length > 0 &&
                                filtered.length === 0 && (
                                    <div className={style.emptyState}>
                                        Ningún personaje matchea "{search}".
                                    </div>
                                )}

                            {!loading &&
                                !error &&
                                filtered.map((character, i) =>
                                    this.renderRow(character, i)
                                )}
                        </div>

                        {!loading && !error && rankingList.length > 0 && (
                            <div className={style.cardFooter}>
                                Top 3 con {totalKillsTop} asesinatos combinados
                            </div>
                        )}
                    </div>
                </div>
            </MainContainer>
        );
    }
}

function mapStateToProps(state) {
    const { initsLoaded } = state;
    return { initsLoaded };
}

export default connect(mapStateToProps)(RankingPage);
